import React from 'react';
import PropTypes from 'prop-types';
import { connectLean } from 'lean-redux';
import { connect } from 'react-redux';
import AssignItem from 'legacy/src/components/assessment/AssignItem';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import { UNITS as COPY } from 'chameleon/ui-stack/utilities/copy';
import connectLeanUpdateAssignments from 'chameleon-src/utility/connectLeanUpdateAssignments';
import { SubunitAssessmentTypes } from 'legacy-packages/unit-outline/src/constants';

const LockedAssignment = ({
  resource,
  assessmentId,
  unitNumber,
  unitTitle,
  isAdminOrCoordinator,
  saveAssignedState,
  onItemAction,
  subunitType = 'PPC',
  disablePpcAutoAssignFlag,
  onAssignCallback,
  useNewAssignModalFlag,
  studentsBySection,
}) => {
  const { displayName } = resource;

  let assignModalTitle = COPY.ASSIGN.MODAL_TITLE(
    unitNumber,
    displayName,
    false,
    unitTitle,
  );

  /**
   * On assign callback
   * */
  const onAssignItem = (assignmentsResponse, totalAssignees) => {
    if (useNewAssignModalFlag) {
      onAssignCallback(assignmentsResponse.assignments, assignModalTitle);
    } else {
      onAssignCallback(totalAssignees, assignModalTitle);
    }

    connectLeanUpdateAssignments({
      assignmentsResponse,
      totalAssignees,
      saveAssignedState,
      onItemAction,
      disablePpcAutoAssignFlag,
      useNewAssignModalFlag,
      studentsBySection,
    });
  };

  let btnToRender = <div />;

  if (subunitType === SubunitAssessmentTypes.PE) {
    btnToRender = (
      <ButtonWithIcon
        tabIndex={0}
        isPrimary
        icon="person_add"
        iconClassName="fill-current text-white"
        accessibility={{
          'aria-label': 'Assign Quiz',
        }}
      >
        Assign
      </ButtonWithIcon>
    );
    assignModalTitle = displayName;
  } else if (disablePpcAutoAssignFlag) {
    btnToRender = (
      <ButtonWithIcon
        isPrimary
        tabIndex={0}
        icon="person_add"
        iconClassName="text-white"
        iconWidth={18}
        iconHeight={18}
        accessibility={{
          'aria-label': 'Assign Quiz',
        }}
      >
        Assign
      </ButtonWithIcon>
    );
  } else {
    btnToRender = (
      <ButtonWithIcon
        isIcon
        isNaked
        className="bg-white"
        tabIndex={0}
        icon="lock"
        iconClassName="text-black"
        accessibility={{
          'aria-label': 'Assign Quiz',
        }}
      />
    );
  }

  return (
    <AssignItem
      selectedGroups={{}}
      groups={[]}
      itemId={Number.parseInt(assessmentId, 10)}
      itemTitle={assignModalTitle}
      onAssignRedirect={false}
      onAssign={onAssignItem}
      button={btnToRender}
      isAdminOrCoordinator={isAdminOrCoordinator}
      isPPC={subunitType === SubunitAssessmentTypes.PPC}
      isLC={subunitType === SubunitAssessmentTypes.LC}
    />
  );
};

LockedAssignment.propTypes = {
  disablePpcAutoAssignFlag: PropTypes.bool,
  onAssignCallback: PropTypes.func,
  useNewAssignModalFlag: PropTypes.bool,
};

LockedAssignment.defaultProps = {
  disablePpcAutoAssignFlag: false,
  onAssignCallback: () => {},
  useNewAssignModalFlag: false,
};

const mapStateToProps = ({ featureFlag, studentsBySection }) => {
  return {
    useNewAssignModalFlag: featureFlag.new_assign_modal,
    studentsBySection,
  };
};

export default connectLean({
  saveAssignedState(
    updatedAssignmentsInfo,
    assignResponse,
    disablePpcAutoAssignFlag = false,
  ) {
    const { assignmentOverview = {}, assignResponses = [] } = this.state;
    const { assignments = [] } = assignmentOverview;
    this.setState({
      //this actually would fix the auto assigned PPCs having View All button, but because don't have
      //support for showing View All performance bars, this will be used only for unassigned PPCs
      isAssigned: disablePpcAutoAssignFlag,
      assignmentOverview: {
        ...assignmentOverview,
        assignments: [...assignments, ...updatedAssignmentsInfo],
      },

      assignResponses: [...assignResponses, ...assignResponse],
    });
  },
})(connect(mapStateToProps)(LockedAssignment));
